(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-cart"]) return;
  try {
    
document.addEventListener('click',async event=>{
  const cart=event.target.closest('[data-cart-section]')||document.querySelector('[data-cart-section]');
  const quantityButton=event.target.closest('[data-cart-minus],[data-cart-plus]');
  if(quantityButton){
    const stepper=quantityButton.closest('.cart-stepper'),input=stepper.querySelector('input'),direction=quantityButton.hasAttribute('data-cart-plus')?1:-1,quantity=Math.max(0,Number(input.value)+direction);
    stepper.classList.add('busy');
    try{const response=await fetch(cart.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:stepper.dataset.lineKey,quantity})});if(!response.ok)throw new Error();location.reload()}catch{stepper.classList.remove('busy')}
    return;
  }
  const addButton=event.target.closest('[data-match-add]');
  if(addButton){
    const variant=addButton.closest('[data-match-slide]').querySelector('[data-match-variant]');addButton.classList.add('busy');addButton.disabled=true;
    try{const response=await fetch(cart.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(variant.value),quantity:1}]})});if(!response.ok)throw new Error();location.reload()}catch{addButton.classList.remove('busy');addButton.disabled=false}
    return;
  }
  const matchArrow=event.target.closest('[data-match-prev],[data-match-next]');
  if(matchArrow){
    const carousel=matchArrow.closest('[data-match-carousel]'),slides=[...carousel.querySelectorAll('[data-match-slide]')],current=slides.findIndex(slide=>!slide.hidden),direction=matchArrow.hasAttribute('data-match-next')?1:-1,next=(current+direction+slides.length)%slides.length;
    slides.forEach((slide,index)=>slide.hidden=index!==next);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-categories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zs-category-carousel'))customElements.define('zs-category-carousel',class extends HTMLElement{
  connectedCallback(){this.track=this.querySelector('.categories');this.prev=this.querySelector('[data-category-prev]');this.next=this.querySelector('[data-category-next]');if(!this.track||!this.prev||!this.next)return;this.update=()=>{this.prev.disabled=this.track.scrollLeft<=1;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2};this.click=e=>{const button=e.target.closest('[data-category-prev],[data-category-next]');if(!button)return;this.track.scrollBy({left:(button.hasAttribute('data-category-next')?1:-1)*this.track.clientWidth*.78,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})};this.addEventListener('click',this.click);this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update()}
  disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('click',this.click);this.track?.removeEventListener('scroll',this.update)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-collection-tabs"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zs-collection-tabs'))customElements.define('zs-collection-tabs',class extends HTMLElement{
  connectedCallback(){this.addEventListener('click',this.onClick)}
  disconnectedCallback(){this.removeEventListener('click',this.onClick)}
  onClick=e=>{const tab=e.target.closest('[role=tab]');if(!tab||!this.contains(tab))return;this.querySelectorAll('[role=tab]').forEach(button=>button.setAttribute('aria-selected',button===tab?'true':'false'));this.querySelectorAll('[role=tabpanel]').forEach(panel=>panel.hidden=panel.id!==tab.getAttribute('aria-controls'));const link=this.querySelector('[data-tab-shop]');if(link)link.href=tab.dataset.collectionUrl;tab.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest',inline:'center'})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-featured-products"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('zs-featured-carousel')) {
  customElements.define('zs-featured-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.zs-featured-mobile-track');
      this.prev = this.querySelector('[data-featured-prev]');
      this.next = this.querySelector('[data-featured-next]');
      if (!this.track || !this.prev || !this.next) return;
      this.update = () => {
        this.prev.disabled = this.track.scrollLeft <= 1;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      this.move = event => {
        const button = event.target.closest('[data-featured-prev], [data-featured-next]');
        if (!button) return;
        const slide = this.track.firstElementChild;
        if (!slide) return;
        const direction = button.hasAttribute('data-featured-next') ? 1 : -1;
        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        this.track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap), behavior: 'smooth' });
      };
      this.addEventListener('click', this.move);
      this.track.addEventListener('scroll', this.update, { passive: true });
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.move);
      this.track?.removeEventListener('scroll', this.update);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zs-product-carousel'))customElements.define('zs-product-carousel',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.zs-product-track');if(!this.track)return;
this.prev=this.querySelector('[data-shelf-prev]');this.next=this.querySelector('[data-shelf-next]');
this.update=()=>{this.prev.disabled=this.track.scrollLeft<=1;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2};
this.move=e=>{const button=e.target.closest('[data-shelf-prev],[data-shelf-next]');if(!button)return;const card=this.track.firstElementChild;if(!card)return;const direction=button.hasAttribute('data-shelf-next')?1:-1;this.track.scrollBy({left:direction*(card.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
this.addEventListener('click',this.move);this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
}
disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('click',this.move);this.track?.removeEventListener('scroll',this.update)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-recommendations"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('zs-recommendation-carousel'))customElements.define('zs-recommendation-carousel',class extends HTMLElement{
connectedCallback(){
this.track=this.querySelector('.zs-recommendation-track');this.prev=this.querySelector('[data-recommendation-prev]');this.next=this.querySelector('[data-recommendation-next]');if(!this.track||!this.prev||!this.next)return;
this.update=()=>{this.prev.disabled=this.track.scrollLeft<=1;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2};
this.move=e=>{const button=e.target.closest('[data-recommendation-prev],[data-recommendation-next]');if(!button)return;const slide=this.track.firstElementChild;if(!slide)return;const direction=button.hasAttribute('data-recommendation-next')?1:-1;const gap=parseFloat(getComputedStyle(this.track).gap)||0;this.track.scrollBy({left:direction*(slide.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
this.addEventListener('click',this.move);this.track.addEventListener('scroll',this.update,{passive:true});this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();
}
disconnectedCallback(){this.observer?.disconnect();this.removeEventListener('click',this.move);this.track?.removeEventListener('scroll',this.update)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zs-search"]) return;
  try {
    
if(!customElements.get('zs-live-search'))customElements.define('zs-live-search',class extends HTMLElement{
connectedCallback(){this.input=this.querySelector('[data-zs-search-input]');this.panel=this.querySelector('[data-zs-search-predictive]');this.clear=this.querySelector('[data-zs-search-clear]');if(!this.input||!this.panel)return;this.timer=0;this.controller=null;this.onInput=()=>{const query=this.input.value.trim();this.clear.hidden=!query;clearTimeout(this.timer);if(query.length<2){this.close();return}this.timer=setTimeout(()=>this.load(query),180)};this.onClear=()=>{this.input.value='';this.clear.hidden=true;this.close();this.input.focus()};this.onKey=e=>{if(e.key==='Escape')this.close()};this.onOutside=e=>{if(!this.contains(e.target))this.close()};this.input.addEventListener('input',this.onInput);this.input.addEventListener('keydown',this.onKey);this.clear?.addEventListener('click',this.onClear);document.addEventListener('click',this.onOutside)}
async load(query){this.controller?.abort();this.controller=new AbortController();this.classList.add('is-loading');this.panel.hidden=false;this.input.setAttribute('aria-expanded','true');const url=new URL(this.input.dataset.predictiveUrl,location.origin);url.searchParams.set('q',query);url.searchParams.set('resources[type]','product,query');url.searchParams.set('resources[limit]','6');url.searchParams.set('resources[options][unavailable_products]','last');url.searchParams.set('section_id',this.input.dataset.sectionId);try{const response=await fetch(url,{signal:this.controller.signal});if(!response.ok)throw Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html');const content=doc.querySelector('[data-zs-predictive-content]');if(content)this.panel.replaceChildren(content)}catch(error){if(error.name!=='AbortError')this.close()}finally{this.classList.remove('is-loading')}}
close(){this.controller?.abort();this.panel.hidden=true;this.panel.replaceChildren();this.input.setAttribute('aria-expanded','false');this.classList.remove('is-loading')}
disconnectedCallback(){clearTimeout(this.timer);this.controller?.abort();this.input?.removeEventListener('input',this.onInput);this.input?.removeEventListener('keydown',this.onKey);this.clear?.removeEventListener('click',this.onClear);document.removeEventListener('click',this.onOutside)}});
document.addEventListener('change',event=>{if(event.target.matches('[data-zs-search-sort]'))event.target.form?.submit()});

  } catch(e) { console.error(e); }
})();
})();
